__turbopack_context__.v({
  "cta-buttons": "style-module-scss-module__12XXIW__cta-buttons",
});
